import styled from "styled-components";

export const TileContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 24px;
  row-gap: 40px;
  margin-bottom: 24px;
`;
